import { FC, useState, useEffect, useMemo } from 'react';
import { useStyles } from './styles';
import {
  Grid,
  Paper,
  IconButton,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { ReactComponent as LogoIcon } from 'assets/logo.svg';
import { useHistory } from 'react-router';
import DoneIcon from '@material-ui/icons/Done';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation } from 'react-query';
// import { handleCompanyUrl } from 'utils/organizationUtils';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CircleIcon from '@mui/icons-material/Circle';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import { getTenantFromSubdomain, isValidTenant } from 'utils/tenantUtils';
const handleDownload = (recoveryCodes: string[]) => {
  if (recoveryCodes.length === 0) {
    alert('No recovery codes available to download.');
    return;
  }
  const fileData = recoveryCodes.join('\n');
  const blob = new Blob([fileData], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'recovery_codes.txt';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const CodeUrl: FC = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const [urlCode, setUrlCode] = useState<string | undefined>();
  const [SecretKey, setSecretKey] = useState<string | null>();
  const [code, setCode] = useState<string>('');
  const [step, setStep] = useState<number>(1);
  const [RecoveryCode, setRecoveryCode] = useState([]);
  const [download, setDownload] = useState(false);
  const [confirmDialog, setconfirmDialog] = useState(false);
  const profile = JSON.parse(localStorage.getItem('Profile') as string);
  const [isValidDomain, setIsValidDomain] = useState<boolean>(true);

  const domain = useMemo(() => {
    const tenant = getTenantFromSubdomain();

    if (tenant === null) {
      setIsValidDomain(false);
      return '';
    }

    if (!isValidTenant(tenant)) {
      setIsValidDomain(false);
      return '';
    }

    setIsValidDomain(true);
    return tenant;
  }, []);
  useEffect(() => {
    const storedUrl = localStorage.getItem('QRCode');
    const secretKey = localStorage.getItem('secretKey');
    if (storedUrl) {
      setUrlCode(storedUrl);
      setSecretKey(secretKey);
    }
  }, []);

  const handleCode = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setCode(value);
    }
  };
  const {
    userStore: { AuthenticatorVerify, RecoveryCodeGenerate, SaveCode },
    notificationStore: { openNotification },
  } = useStore();

  const RecoveryCodeRequest = useMutation(async () => await RecoveryCodeGenerate(), {
    mutationKey: 'RecoveryCodeRequest',
    onSuccess: (data) => {
      setRecoveryCode(data.recovery_codes);
    },
    onError: ({ message }: Error) => {
      openNotification('error', message || 'Something went wrong');
    },
  });
  const SaveCodeRequest = useMutation(async () => await SaveCode(), {
    mutationKey: 'SaveCodeRequestRequest',
    onSuccess: () => {
      if (profile?.permission !== 'EndUser' && profile?.permission !== 'Manager') {
        if (!isValidDomain) {
          const hostName = domain || localStorage.getItem('domain');
          const protocol = window.location.protocol;
          const hostname = window.location.hostname;
          const port = window.location.port;
          const token = localStorage.getItem('token')?.replace('Bearer ', '');
          const orgName = localStorage.getItem('organizationName');
          if (hostName && !hostname.startsWith(`${hostName}.`)) {
            const isLocalhost = hostname.includes('localhost');
            let baseHost;
            if (isLocalhost) {
              baseHost = `localhost${port ? ':' + port : ''}`;
            } else {
              const parts = hostname.split('.');
              baseHost = parts.length === 2 ? hostname : parts.slice(1).join('.');
            }
            const cleanHostName = hostName.replace(/^https?:\/\//, '');
            const redirectUrl = `${protocol}//${cleanHostName}.${baseHost}/dashboard?token=${token}&userData=${encodeURIComponent(
              JSON.stringify(profile)
            )}&orgName=${encodeURIComponent(orgName || '')}`;
            window.location.href = redirectUrl;
          }
        } else {
          history.push('/dashboard');
        }
      } else {
        if (!isValidDomain) {
          const hostName = domain || localStorage.getItem('domain');
          const protocol = window.location.protocol;
          const hostname = window.location.hostname;
          const port = window.location.port;
          const token = localStorage.getItem('token')?.replace('Bearer ', '');
          const orgName = localStorage.getItem('organizationName');
          if (hostName && !hostname.startsWith(`${hostName}.`)) {
            const isLocalhost = hostname.includes('localhost');
            let baseHost;
            if (isLocalhost) {
              baseHost = `localhost${port ? ':' + port : ''}`;
            } else {
              const parts = hostname.split('.');
              baseHost = parts.length === 2 ? hostname : parts.slice(1).join('.');
            }
            // Clean hostName to remove any protocol if present
            const cleanHostName = hostName.replace(/^https?:\/\//, '');
            const redirectUrl = `${protocol}//${cleanHostName}.${baseHost}/users?token=${token}&userData=${encodeURIComponent(
              JSON.stringify(profile)
            )}&orgName=${encodeURIComponent(orgName || '')}`;
            window.location.href = redirectUrl;
          }
        } else {
          history.push('/users');
        }
      }
    },
    onError: ({ message }: Error) => {
      openNotification('error', message || 'Something went wrong');
    },
  });
  const VertifyRequest = useMutation(
    () => {
      if (!code || isNaN(Number(code))) {
        throw new Error('Code is required and must be a number');
      }
      return AuthenticatorVerify({ code });
    },
    {
      mutationKey: 'VertifyRequest',
      onSuccess: () => {
        setStep(2);
        RecoveryCodeRequest.mutate();
      },
      onError: ({ message }: Error) => {
        openNotification('error', message ? message : 'Something went wrong');
      },
    }
  );
  useAppPreloader(VertifyRequest.isLoading || RecoveryCodeRequest.isLoading);

  return (
    <>
      <Grid item className={classes.container}>
        <div className={classes.topBar}>
          <LogoIcon style={{ marginLeft: '40px', width: '140px', height: '52px' }} />
        </div>
        <Grid container justify='center'>
          <Grid item xs={12}>
            <h1 style={{ textAlign: 'center', fontSize: '34px', marginTop: '10px' }}>
              Enable Two-Factor Authenticator
            </h1>
          </Grid>
          <Grid container justify='center'>
            <div className={classes.topBars}>
              <div className={classes.flex}>
                {step < 2 ? (
                  <div className={classes.circle}>1</div>
                ) : (
                  <div style={{ backgroundColor: '#64C968' }} className={classes.circle}>
                    <DoneIcon className={classes.icon} />
                  </div>
                )}
              </div>
              <div className={classes.horizontalLine}>
                <hr className={classes.hr} />
              </div>
              <div className={classes.flex}>
                <div className={step < 2 ? classes.disabledCircle : classes.circle}>2</div>
              </div>
            </div>
          </Grid>
          <Grid item lg={6}>
            <Paper className={classes.paper} elevation={3} style={{ margin: '10px' }}>
              {step === 1 ? (
                <>
                  <h1 style={{ fontWeight: 500, fontSize: '30px' }}>Set up Google Authenticator</h1>
                  <Grid container style={{ marginTop: '15px' }}>
                    <p style={{ color: '#59636e' }}>
                      Authenticator apps and browser extensions like 1Password, Authy, Microsoft Authenticator, etc.
                      generate one-time passwords that are used as a second factor to verify your identity when prompted
                      during sign-in.
                    </p>
                  </Grid>
                  <Grid container style={{ marginTop: '20px' }}>
                    <p style={{ fontWeight: 500, fontSize: '20px' }}>Scan the QR code</p>
                  </Grid>
                  <Grid container style={{ marginTop: '10px' }}>
                    <p style={{ color: '#59636e' }}>Use an authenticator app or browser extension to scan.</p>
                  </Grid>
                  <Grid container>{urlCode && <img src={urlCode} alt='QR Code' />}</Grid>
                  <Grid container style={{ marginTop: '20px' }}>
                    <p style={{ color: '#59636e' }}>
                      Unable to scan? You can use the
                      <Button style={{ color: '#0969da' }} onClick={() => setconfirmDialog(true)}>
                        setup key
                      </Button>
                      to manually configure your authenticator app.
                    </p>
                  </Grid>
                  <h5 style={{ marginTop: '20px', fontWeight: '500', fontSize: '20px' }}>
                    Verify the code from the app
                  </h5>
                  <Grid container>
                    <TextField
                      style={{ marginTop: '20px', width: '50%' }}
                      id='code'
                      value={code}
                      onChange={handleCode}
                      required
                      placeholder='Enter Code'
                      variant='outlined'
                    />
                  </Grid>
                  <Grid container justify='flex-end' spacing={2} style={{ marginTop: 16 }}>
                    <Grid item>
                      <Button onClick={() => history.goBack()}>Cancel</Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant='contained'
                        color='primary'
                        onClick={() => {
                          VertifyRequest.mutate();
                        }}
                      >
                        Continue
                      </Button>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  <h1 className={classes.title}> Download your recovery codes</h1>
                  <Grid container justify='center'>
                    <Grid container justify='center' style={{ marginTop: '20px' }}>
                      <p style={{ color: 'grey' }}>
                        You can use recovery codes as a second factor to authenticate in case you lose access to your
                        device. We recommend saving them with a secure password manager such as 1Password, Authy, or
                        Keeper.
                      </p>
                    </Grid>
                    <div className={classes.alertboxes}>
                      <Grid className={classes.alertmessage}>
                        <div className={classes.alertbox}>
                          <div>
                            <ErrorOutlineIcon className={classes.alertIcon} />
                          </div>
                          <div>
                            <div className={classes.alertTitle}>Keep your recovery codes in a safe spot</div>
                            <p>
                              {' '}
                              If you lose your device and don't have the recovery codes, you will lose access to your
                              account.{' '}
                            </p>
                          </div>
                        </div>
                      </Grid>
                    </div>
                    {RecoveryCode.length > 0 && (
                      <Paper
                        style={{
                          backgroundColor: '#f5f5f5',
                          padding: '16px',
                          maxHeight: '50vh',
                          overflowY: 'auto',
                        }}
                      >
                        <Grid container spacing={2}>
                          {RecoveryCode.map((item, index) => (
                            <Grid item xs={6} key={index}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <CircleIcon style={{ fontSize: '10px' }} />
                                <span>{item}</span>
                              </div>
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                    )}
                    <Grid container justify='flex-end' spacing={2} style={{ marginTop: 16 }}>
                      <Grid item>
                        {RecoveryCode.length > 0 && (
                          <Button
                            onClick={() => {
                              handleDownload(RecoveryCode);
                              setDownload(true);
                            }}
                            style={{ color: '#4682B4' }}
                          >
                            <DownloadIcon style={{ color: '#4682B4' }} />
                            Download
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                    <div style={{ width: '100%', marginTop: '20px' }}>
                      <hr style={{ borderTop: '1px solid #ccc' }} />
                    </div>
                    <Grid container justify='flex-end' spacing={2} style={{ marginTop: 16 }}>
                      <Grid item>
                        <Button onClick={() => history.goBack()}>Cancel</Button>
                      </Grid>
                      <Grid item>
                        <Button
                          disabled={!download}
                          variant='contained'
                          color='primary'
                          // style={{
                          //   opacity: download ? 1 : 0.6,
                          //   cursor: download ? 'pointer' : 'not-allowed',
                          // }}
                          onClick={() => SaveCodeRequest.mutate()}
                        >
                          I have saved my recovery code
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Dialog open={confirmDialog}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <DialogTitle>Your two-factor secret</DialogTitle>
          <IconButton>
            <CloseIcon
              onClick={() => {
                setconfirmDialog(false);
              }}
            />
          </IconButton>
        </div>
        <DialogContent>
          <DialogContentText>{SecretKey}</DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
});

export default CodeUrl;
